<script>
	import { speak } from './speak';

	import { nachrichten } from './store';

	export let index = 0;
	export let text = '';
	export let textDisplay = '';

	//@ts-ignore
	function remove(e) {
		e.stopPropagation();
		console.log(index);
		$nachrichten.splice(index, 1);
		nachrichten.set($nachrichten);
	}
</script>

<button
	on:click={() => {
		speak(text);
	}}
	class="relative aspect-square w-full bg-red-600 hover:bg-red-400 rounded-lg drop-shadow text-white p-2 text-2xl font-medium"
>
	<span class="absolute top-0 right-2 hover:scale-110" on:click={remove}>x</span>
	{textDisplay || text}</button
>
